import { createStore, stateSetterHandler } from '@muvi/react-common';
import { isDevtoolsEnabled } from '@/logic/state/store-devtools';

import { storage } from '../../libs';

export enum NotificationTag {
  GUEST = 'guest',
  AUTH = 'auth',
  LOGGED_IN = 'logged_in',
}

export type deviceIdState = {
  muviDeviceId: string | null;
  oneSignalUserType: NotificationTag;
};

const initState: deviceIdState = {
  muviDeviceId: storage.muviDeviceId.get() ?? null,
  oneSignalUserType: storage.oneSignalUserType.get(),
};

export const useOneSignalCustomState = createStore({
  name: 'one-signal-custom-state',
  devtools: isDevtoolsEnabled,
  persist: false,
})(initState, set => {
  const handler = stateSetterHandler(set);
  return {
    setDeviceId: handler('muviDeviceId', u => storage.muviDeviceId.set(u)),
    setOneSignalUserType: handler('oneSignalUserType', u =>
      storage.oneSignalUserType.set(u)
    ),
  };
});
